export default __webpack_public_path__ + "static/media/test-assignment-zechmann-hero-fr.7a79930f.png";